import FavoriteApi from "@/api/favorite.api";
import mime from "mime";


class FavoriteService {
    async getGroups() {
        const { data } = await FavoriteApi.getGroups();
        return data;
    }

    async getItems(groupId) {
        const { data } = await FavoriteApi.getItems(groupId);

        return data.map(item => {
            const index = item.fileRelativePath.lastIndexOf("/");

            return {
                id: item.id,
                sortOrder: item.sortOrder,
                path: index === 0
                    ? "/" : item.fileRelativePath.substring(0, index),
                name: item.fileRelativePath.substring(index + 1)
            };
        });
    }

    createGroup(name) {
        return FavoriteApi.createGroup(name);
    }

    async addFavorite(groupId, files) {
        const mediaFiles = files
                .filter(file => this.isPlayableMedia(file))
                .map(file => this.convertFile(file));

        if (!mediaFiles.length)
            return false;

        return FavoriteApi.addFavorite(groupId, mediaFiles);
    }

    deleteItem(groupId, itemId, autoDelete) {
        return FavoriteApi.deleteItem(groupId, itemId, autoDelete);
    }

    isPlayableMedia(file) {
        const type = mime.getType(file.name)?.toLowerCase() ?? "";

        return (
            type.startsWith("video") || type.startsWith("audio")
        );
    }

    convertFile(file) {
        return {
            fileRelativePath: file.path === "/"
                    ? `/${file.name}` : `${file.path}/${file.name}`
        };
    }

    async renameGroup(groupId, name) {
        return FavoriteApi.renameGroup(groupId, name);
    }

    async deleteGroup(groupId) {
        return FavoriteApi.deleteGroup(groupId);
    }

    async reorderGroups(groups) {
        return FavoriteApi.reorderGroups(groups);
    }

    markFileMissing(groupId, itemId) {
        return FavoriteApi.markFileMissing(
            groupId,
            itemId
        );
    }
}
export default new FavoriteService();